import { render, staticRenderFns } from "./ConverterEmbalagemPedido.vue?vue&type=template&id=2a50b5da&scoped=true"
import script from "./ConverterEmbalagemPedido.vue?vue&type=script&lang=js"
export * from "./ConverterEmbalagemPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a50b5da",
  null
  
)

export default component.exports